// extracted by mini-css-extract-plugin
export default {"spinner":"LeftSidebar_spinner__mLxnj","submenu":"LeftSidebar_submenu__UAqaj","clientLabel":"LeftSidebar_clientLabel__WQana","settingsIcon":"LeftSidebar_settingsIcon__+qw2W"};